import React from 'react';

function Reportes() {
	return (
		<div>Reportes</div>
	);
}

export default Reportes;
